module.exports = __webpack_public_path__ + "img/enterprise_btn.ea402e9f.png";